module.exports = __webpack_public_path__ + "static/media/exit.3a44c9dc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/scenes/AppFrame/images/icons/exit.svg
// module id = 753
// module chunks = 0